import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer } from "react-leaflet";
import ShowCompanyLocations from "../components/showCompany";

export function CompanyLocationMaps({ companies, handleSelectedIndex }) {
  return (
    <MapContainer
      style={{ height: "550px", width: "100%", zIndex: "0" }}
      center={[25.488707193555445, 28.00789997581698]}
      zoom={3}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <ShowCompanyLocations
        companies={companies}
        handleSelectedIndex={handleSelectedIndex}
      />
    </MapContainer>
  );
}
